export function eventTarget() {
    let eventBanner = document.querySelector('.event_banner');
    eventBanner.addEventListener('click', () => {
        window.open('https://moiitee.notion.site/1fbc646c8ce7804ba3fcd7245c695448', '_blank');
    });

}